module.exports = "<p class=\"{{$ctrl.class}}\">{{$ctrl.translatedText}}</p>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/lsp-page-sub-header/lsp-page-sub-header.html
// module id = 1817
// module chunks = 0